import React from 'react'
import {useIntl} from 'react-intl'

interface UsersListToolbarProps {
  selectedUsersCount: number
  totalUsers: number
  onAddUser: () => void
  onBulkDelete: () => void
  onSearch: (term: string) => void
}

const UsersListToolbar: React.FC<UsersListToolbarProps> = ({
  selectedUsersCount,
  totalUsers,
  onAddUser,
  onBulkDelete,
  onSearch,
}) => {
  const intl = useIntl()

  return (
    <div className='d-flex justify-content-between align-items-center flex-wrap flex-sm-nowrap mb-5'>
      <div className='d-flex flex-wrap my-2'>
        <button
          type='button'
          className='btn btn-primary btn-sm me-3'
          onClick={onAddUser}
        >
          <i className='fas fa-plus'></i>
          {intl.formatMessage({id: 'USERS.ADD_USER'})}
        </button>
        
        {selectedUsersCount > 0 && (
          <button
            type='button'
            className='btn btn-danger btn-sm'
            onClick={onBulkDelete}
          >
            <i className='fas fa-trash'></i>
            {intl.formatMessage({id: 'USERS.DELETE_SELECTED'})} ({selectedUsersCount})
          </button>
        )}
      </div>
      
      <div className='d-flex align-items-center position-relative my-1'>
        <i className='fas fa-search position-absolute ms-3'></i>
        <input
          type='text'
          className='form-control form-control-sm w-250px ps-9'
          placeholder={intl.formatMessage({id: 'USERS.SEARCH_PLACEHOLDER'})}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      
      <div className='d-flex align-items-center'>
        <span className='text-muted fs-7'>
          {intl.formatMessage({id: 'USERS.TOTAL_USERS'}, {count: totalUsers})}
        </span>
      </div>
    </div>
  )
}

export {UsersListToolbar}
